import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f36cb18a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "TableBG W-100",
  cellpading: "0",
  cellspacing: "0"
}
const _hoisted_7 = { class: "D-Flex P_75em" }
const _hoisted_8 = { class: "D-Flex P1em" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = { class: "CookiesDialogFooter" }
const _hoisted_11 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.CategoriesImagesAray.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.Translate('No Categories Found')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CategoriesImagesAray, (category, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(category.Name), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_CookiesImageInput, {
                      onSelected: ($event: any) => (_ctx.UploadImage(index, category)),
                      Default: category.ImgUrl,
                      Res: 'category_' + index,
                      style: {"border-radius":"var(--rad3)","width":"5em","height":"5em"}
                    }, null, 8, ["onSelected", "Default", "Res"])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _hoisted_9
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          style: {"background":"var(--colorr1)"},
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Cancel')), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.EditItem('CategoriesImages', _ctx.$store.state.CookiesConfig.CategoriesImages))),
          style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Save')), 5)
      ])
    ])
  ], 64))
}